<ng-container
  *transloco="let t; read: 'calculator_result.charts.monthly-chart'">
  <psc-month-selector [solarCalculatorResult]="calculatorResultValue"
                      (monthChanged)="onMonthChange($event)"></psc-month-selector>
  <div class="w-[100%] mb-10">
    <canvas baseChart class="chart limited-max-height"
            [data]="elEnergyChartData"
            [height]="resultChartsService.regularChartHeight"
            [options]="elEnergyChartOptions"
            [type]="elEnergyChartType"></canvas>
  </div>

  <div class="-ml-[5000px] fixed flex flex-col items-center" *ngIf="!mockData">
    <canvas baseChart class="chart limited-max-height"
            *ngFor="let chartData of allMonthlyResults"
            [width]="resultChartsService.chartWidth"
            [height]="resultChartsService.chartForPdfHeight"
            [data]="chartData"
            [options]="elEnergyChartOptions"
            [type]="elEnergyChartType"></canvas>
  </div>

</ng-container>
